import { API_BASE_URL } from './config';
import { authHeadersForGet, authHeadersJson } from './http';
import type {
  BankingAccount,
  CreateBankingAccountPayload,
} from '../types/banking-account';

const BASE = `${API_BASE_URL}/banking-accounts`;

async function parseJson<T>(res: Response): Promise<T> {
  const text = await res.text();
  if (!text) {
    return {} as T;
  }
  return JSON.parse(text) as T;
}

export const bankingAccountsApi = {
  async list(): Promise<BankingAccount[]> {
    const res = await fetch(BASE, { headers: authHeadersForGet() });
    if (!res.ok) {
      throw new Error(`Error ${String(res.status)} al cargar cuentas`);
    }
    return parseJson<BankingAccount[]>(res);
  },

  async create(payload: CreateBankingAccountPayload): Promise<BankingAccount> {
    const res = await fetch(BASE, {
      method: 'POST',
      headers: authHeadersJson(),
      body: JSON.stringify(payload),
    });
    if (!res.ok) {
      const err = await res.text();
      throw new Error(err || `Error ${String(res.status)}`);
    }
    return parseJson<BankingAccount>(res);
  },

  async update(
    reference: string,
    payload: Partial<CreateBankingAccountPayload>,
  ): Promise<BankingAccount> {
    const res = await fetch(`${BASE}/${reference}`, {
      method: 'PUT',
      headers: authHeadersJson(),
      body: JSON.stringify(payload),
    });
    if (!res.ok) {
      const err = await res.text();
      throw new Error(err || `Error ${String(res.status)}`);
    }
    return parseJson<BankingAccount>(res);
  },

  async remove(reference: string): Promise<void> {
    const res = await fetch(`${BASE}/${reference}`, {
      method: 'DELETE',
      headers: authHeadersForGet(),
    });
    if (!res.ok && res.status !== 204) {
      throw new Error(`Error ${String(res.status)} al eliminar`);
    }
  },

  async setDefault(reference: string): Promise<BankingAccount> {
    const res = await fetch(`${BASE}/${reference}/default`, {
      method: 'PATCH',
      headers: authHeadersForGet(),
    });
    if (!res.ok) {
      const err = await res.text();
      throw new Error(err || `Error ${String(res.status)}`);
    }
    return parseJson<BankingAccount>(res);
  },
};
